var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgWordDoc = function SvgWordDoc(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.22383 8.99401L4.82383 15.394C4.90063 15.7012 5.1514 15.9342 5.4634 15.9882C5.77541 16.0423 6.08993 15.9072 6.26558 15.6437L7.19994 14.2422L8.1343 15.6437C8.30995 15.9072 8.62447 16.0423 8.93648 15.9882C9.24849 15.9342 9.49926 15.7012 9.57606 15.394L11.1761 8.99401L9.62383 8.60596L8.46244 13.2515L7.86558 12.3562C7.71721 12.1337 7.46742 12 7.19994 12C6.93246 12 6.68267 12.1337 6.5343 12.3562L5.93744 13.2515L4.77606 8.60596L3.22383 8.99401Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.6 0C4.27452 0 3.2 1.07452 3.2 2.4V4.8H2.4C1.07452 4.8 0 5.87452 0 7.2V16.8C0 18.1255 1.07452 19.2 2.4 19.2H3.2V21.6C3.2 22.9255 4.27452 24 5.6 24H21.6C22.9255 24 24 22.9255 24 21.6V2.4C24 1.07452 22.9255 0 21.6 0H5.6ZM2.4 6.4C1.95817 6.4 1.6 6.75817 1.6 7.2V16.8C1.6 17.2418 1.95817 17.6 2.4 17.6H12C12.4418 17.6 12.8 17.2418 12.8 16.8V7.2C12.8 6.75817 12.4418 6.4 12 6.4H2.4Z",
    fill: "currentColor"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgWordDoc);
export { ForwardRef as ReactComponent };